import React from 'react';
import ReferenceCurrency from './ReferenceCurrency.jsx';

export default function TasterOffer({ offer, onChoose }) {
    // Catalog amounts are minor HKD units; the shared estimate uses major units.
    const amount = offer.amount / 100;
    return <div className="btl-taster-offer">
        <button type="button" onClick={onChoose}>
            <span className="font-display text-xs text-book-muted">Taster access</span>
            <span className="font-display font-semibold text-sm">
                Try {offer.durationDays} days · HK${amount.toFixed(2)} <span aria-hidden="true">→</span>
            </span>
        </button>
        <ReferenceCurrency amount={amount} compact currencyDisplay="code" />
    </div>;
}
